// extracted by mini-css-extract-plugin
export var resetButton = "g3_pD";
export var selected = "g3_mW";
export var tab = "g3_pF";